import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../api-config';


const Documentos = () => {
  const [file, setFile] = useState(null);
  const [databases, setDatabases] = useState([]);
  const [selectedDb, setSelectedDb] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [waiting,setWaiting] = useState(false);
  useEffect(() => {
    
    const fetchDatabases = async () => {
      try {
        const response = await axios.get(`${API_URL}/trading-api/agent/get_db_list`);
        setDatabases(response.data);
        setSelectedDb(response.data[0]); // Set the first database as default
      } catch (error) {
        console.error('Error fetching databases:', error);
      }
    };

    fetchDatabases();
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    const fileSizeLimit = 1000 * 1024; // 32KB limit

    if (selectedFile) {
      if (selectedFile.size > fileSizeLimit) {
        setErrorMessage('File size should be less than 1MB');
        setFile(null);
      } else if (!selectedFile.name.endsWith('.md')) {
        setErrorMessage('Only .md files are allowed');
        setFile(null);
      } else {
        setErrorMessage('');
        setFile(selectedFile);
      }
    }
  };

  const handleDbChange = (e) => {
    setSelectedDb(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      setErrorMessage('Please select a valid file');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    setWaiting(true);
    try {
      

      const response = await axios.post(`${API_URL}/trading-api/agent/uploadfile/${selectedDb}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'accept': 'application/json'
        }
      });
      console.log('File uploaded successfully:', response.data);
      window.location.href = '/admin_panel';
    } catch (error) {
      console.error('Error uploading file:', error);
    }
    setWaiting(false);
  };

  return (
    <div className="max-w-md mx-auto mt-10 text-white">
      <h1 className="text-2xl font-bold mb-6">Subir Documentos</h1>
      <form onSubmit={handleSubmit} className="bg-transparent border-2 p-6 rounded-lg shadow-md">
        <div className="mb-4">
          <label htmlFor="db" className="block text-white font-bold mb-2">Base de Datos:</label>
          <select
            id="db"
            value={selectedDb}
            onChange={handleDbChange}
            className="w-full px-3 py-2 border border-gray-300 text-black rounded-md mb-4"
          >
            {databases.map((db) => (
              <option key={db} value={db}>{db}</option>
            ))}
          </select>
        </div>
        <div className="mb-4">
          <label htmlFor="file" className="block text-white font-bold mb-2">Archivo:</label>
          <input
            type="file"
            id="file"
            onChange={handleFileChange}
            className="w-full px-3 py-2 border border-gray-300 text-black rounded-md text-white"
            required
          />
          {errorMessage && <p className="mt-2 text-red-500">{errorMessage}</p>}
        </div>
        {!waiting?<button
          type="submit"
          className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 transition duration-300"
        >
          Subir Archivo
        </button>: <button 
        disabled={true}
        className="w-full bg-white text-black py-2 px-4 rounded-md  transition duration-300">....Subiendo documento</button>}
      </form>
    </div>
  );
};

export default Documentos;
